import {CRMView} from "../../CRMModel/view/CRMView";
import {AdministratorBaseView} from "../../AdministratorModel/view/AdministratorBaseView";
import {AffiliateBaseView} from "../../AffiliateModel/view/AffiliateBaseView";
import {MessageBaseView} from "../../MessageModel/view/MessageBaseView";
import {AiFraudVerdictType} from "../../ExpertRoleModel/constants/AiFraudVerdictEnum";

export class SearchAssignationSalesResultView {
    id: number;
    assignationDate: Date | null;
    status: number;
    activity: CRMView;
    opportunity: OpportunityView;
    sales: AdministratorBaseView;
    partnerRfp: PartnerRfpView;
    member: MemberView;

    constructor(data?: any) {
        this.id = data?.id ?? 0;
        this.assignationDate = data?.assignationDate ? new Date(data.assignationDate): null;
        this.status = data?.status ?? 0;
        this.activity = data?.activity ? new CRMView(data.activity) : new CRMView();
        this.opportunity = data?.opportunity ? new OpportunityView(data.opportunity) : new OpportunityView();
        this.sales = data?.sales ? new AdministratorBaseView(data.sales) : new AdministratorBaseView();
        this.partnerRfp = data?.partnerRfp ? new PartnerRfpView(data.partnerRfp) : new PartnerRfpView();
        this.member = data?.member ? new MemberView(data.member) : new MemberView();
    }
}

class PartnerRfpView {
    id: number;
    utmMedium: string;
    utmSource: string;
    utmCampaign: string;
    region: RegionView;
    affiliate: AffiliateBaseView;

    constructor(data?: any) {
        this.id = data?.id ?? 0;
        this.utmMedium = data?.utmMedium ?? "";
        this.utmSource = data?.utmSource ?? "";
        this.utmCampaign = data?.utmCampaign ?? "";
        this.region = data?.region ? new RegionView(data.region) : new RegionView();
        this.affiliate = data?.affiliate ? new AffiliateBaseView(data.affiliate) : new AffiliateBaseView();
    }
}

class MemberView {
    id: number;
    email: string;
    status: number;
    firstName: string;
    lastName: string;
    company: CompanyView;
    expertRole: ExpertRoleView;
    aiFraudVerdict: AiFraudVerdictType | null;

    constructor(data?: any) {
        this.id = data?.id ?? 0;
        this.email = data?.email ?? "";
        this.status = data?.status ?? 0;
        this.firstName = data?.firstName ?? "";
        this.lastName = data?.lastName ?? "";
        this.company = data?.company ? new CompanyView(data.company) : new CompanyView();
        this.expertRole = data?.expertRole ? new ExpertRoleView(data.expertRole) : new ExpertRoleView();
        this.aiFraudVerdict = data?.aiFraudVerdict ?? null;
    }
}

class CompanyView {
    name: string;
    telNumber: string;
    zipString: string;
    vatNumber: string;
    address1: string;
    address2: string;
    cityString: string;

    constructor(data?: any) {
        this.name = data?.name ?? "";
        this.telNumber = data?.telNumber ?? "";
        this.zipString = data?.zipString ?? "";
        this.vatNumber = data?.vatNumber ?? "";
        this.address1 = data?.address1 ?? "";
        this.address2 = data?.address2 ?? "";
        this.cityString = data?.cityString ?? "";
    }
}

class RegionView {
    id: number;
    name: string;

    constructor(data?: any) {
        this.id = data?.id ?? 0;
        this.name = data?.name ?? "";
    }
}

class OpportunityView {
    id: number;
    description: string;
    closeDate: Date | null;
    amount: number;
    probability: number;
    type: number;
    status: number;

    constructor(data?: any) {
        this.id = data?.id ?? 0;
        this.description = data?.description ?? "";
        this.closeDate = data?.closeDate ? new Date(data.closeDate) : null;
        this.amount = data?.amount ?? 0;
        this.probability = data?.probability ?? 0;
        this.type = data?.type ?? 0;
        this.status = data?.status ?? 0;
    }
}

class ExpertRoleView {
    id: number;
    expertBusinessTypes: ExpertBusinessTypeView[];
    administratorModel: AdministratorBaseView;

    constructor(data?: any) {
        this.id = data?.id ?? 0;
        this.expertBusinessTypes = data?.expertBusinessTypes ? data.expertBusinessTypes.map((type: any) => new ExpertBusinessTypeView(type)) : [];
        this.administratorModel = data?.administratorModel ? new AdministratorBaseView(data.administratorModel) : new AdministratorBaseView();
    }
}

class ExpertBusinessTypeView {
    id: number;
    businessTypeModel: BusinessTypeView;

    constructor(data?: any) {
        this.id = data?.id ?? 0;
        this.businessTypeModel = data?.businessTypeModel ? new BusinessTypeView(data.businessTypeModel) : new BusinessTypeView();
    }
}

class BusinessTypeView {
    id: number;
    translatedName: MessageBaseView;

    constructor(data?: any) {
        this.id = data?.id ?? 0;
        this.translatedName = data?.translatedName ? new MessageBaseView(data.translatedName) : new MessageBaseView();
    }
}